import { API2_HOST } from '@/utils/constants';

import fetchData from '../http';
import { IBaseResponse, IResult } from '../types/common';
import {
  IGetMessageListParams,
  IMessageListRes,
  INoticeMessage,
  INoticeModule,
  IReadAllParams,
  IReadMessageParams,
} from './types';

export const readAllMessage = (params: IReadAllParams) => {
  const url = `${API2_HOST}/v2/private/message/read-all`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IReadAllParams>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const readMessage = (params: IReadMessageParams) => {
  const url = `${API2_HOST}/v2/private/message/read`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<any>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const getMessageList = (params: IGetMessageListParams) => {
  const url = `${API2_HOST}/notification-site/v2/private/message/list`;
  return new Promise<IMessageListRes>((resolve, reject) => {
    fetchData
      .get<IBaseResponse<IMessageListRes>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result as IMessageListRes);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const getModuleList = () => {
  const url = `${API2_HOST}/v2/private/message/module/list`;
  return new Promise<Array<INoticeModule>>((resolve, reject) => {
    fetchData
      .get<IBaseResponse<Array<INoticeModule>>>(url)
      .then((res) => {
        resolve(res.result as Array<INoticeModule>);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const getUnread = (params: IGetMessageListParams) => {
  const url = `${API2_HOST}/v2/private/message/is-unread`;
  return new Promise((resolve, reject) => {
    fetchData
      .get<IBaseResponse<Array<INoticeModule>>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const unsubscribeNotice = (params: { id: number }) => {
  const url = `${API2_HOST}/v2/private/message/unsubscribe`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error: any) => {
        reject(error?.response ? error.response.data : error);
      });
  });
};
